module.exports = __webpack_public_path__ + "_assets/img/checkin-v2.927ede4f.svg";